import React, { useState, useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { m } from 'framer-motion';
import { fadeIn } from '../../Functions/GlobalAnimations';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import config from '../../config';
import Gouvernerat from "../../utils/Gouvernerat.json";
import { Country } from "country-state-city";
import Buttons from '../../Components/Button/Buttons';

const initialState = {
  _id: '',
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  phone_1: '',
  company_name: '',
  tax_registre: '',
  password: '',
  adresse: {},
  conditions_generales_acceptees: false,
};

const Register = (props) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isPasswordVisibleConfirme, setIsPasswordVisibleConfirme] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [addClient, setAddClient] = useState(initialState);
  const [address, setAddress] = useState({
    pays: '',
    Gouvernorat: '',
    Ville: '',
    adresse: '',
  });
  const [Gouvernerats] = useState(Gouvernerat);
  const [NomGouvernerat, setNomGouvernerat] = useState('');
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState({
    name: '',
    isoCode: '',
  });
  const navigate = useNavigate();

  useEffect(() => {
    const tunisia = Country.getAllCountries()[223];
    setSelectedCountry(tunisia);
    setAddress((prev) => ({ ...prev, pays: tunisia?.name || '' }));
  }, []);

  const onChangeInputAdresse = (e) => {
    const { name, value } = e.target;
    setAddress((prev) => {
      const newAddress = { ...prev, [name]: value };
      setAddClient((prevClient) => ({ ...prevClient, adresse: newAddress }));
      return newAddress;
    });
  };

  const handleGouvernoratChange = (event) => {
    const selectedGouv = event.target.value;
    setNomGouvernerat(selectedGouv);
    setAddress((prev) => ({ ...prev, Gouvernorat: selectedGouv }));
    
    const gouvernorat = Gouvernerats.Gouvernorat.find((g) => g.Nom === selectedGouv);
    setCities(gouvernorat?.Villes || []);
    setAddClient((prev) => ({ ...prev, adresse: { ...prev.adresse, Gouvernorat: selectedGouv } }));
  };

  const validatePassword = (pwd) => {
    if (!pwd) return "Le mot de passe est requis";
    if (pwd.length < 10) return "Le mot de passe doit contenir au moins 10 caractères";
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{10,}$/.test(pwd)) {
      return "Le mot de passe doit contenir au moins une lettre majuscule, une lettre minuscule et un chiffre";
    }
    return "";
  };

  const AjouterClient = async (e) => {
    e.preventDefault();
    const pwdError = validatePassword(addClient.password);
    if (pwdError) {
      toast.error(pwdError);
      return;
    }
    if (addClient.password !== confirmPassword) {
      toast.error("Les mots de passe ne correspondent pas.");
      return;
    }
    if (!addClient.conditions_generales_acceptees) {
      toast.error('Vous devez accepter les termes et conditions.');
      return;
    }
    try {
      await axios.post(`${config.REACT_APP_API_URL}/register_customer`, addClient,{
            headers: { 
            'x-api-key': config.SITE_API_KEY
           }});
      toast.success('Compte créé avec succès');
      setTimeout(() => {
        setAddClient(initialState);
        setConfirmPassword('');
        setAddress({ pays: selectedCountry.name, Gouvernorat: '', Ville: '', adresse: '' });
        setNomGouvernerat('');
        setCities([]);
        navigate('/login-register');
      }, 1500);
    } catch (error) {
      toast.error(error.response?.data?.message || 'Erreur lors de la création du compte');
    }
  };

  const onChangeInputAdd = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setAddClient({ ...addClient, [name]: checked });
    } else if (name === "confirmPassword") {
      setConfirmPassword(value);
    } else {
      const isNumeric = /^\d*$/.test(value);
      if ((name === 'phone' || name === 'phone_1') && value && !isNumeric) {
        toast.error('Le téléphone doit contenir uniquement des chiffres.');
        return;
      }
      setAddClient({ ...addClient, [name]: value });
      
      if (name === "password") {
        setPasswordError(validatePassword(value));
      }
    }
  };

  return (
    <div style={props.style}><section className="bg-lightgray py-[25px]">
            <ToastContainer position="bottom-left" className="mt-40" />
            <Container>
              <Row className="items-center justify-center">
                
              </Row>
            </Container>
          </section>
      <m.section className="py-[130px] overflow-hidden lg:py-[90px] md:py-[75px] sm:py-[50px]" {...fadeIn}>
        <Container>
          <Row className="justify-center">
            <Col xl={8} md={10} className="lg:px-[30px] md:px-[15px] mx-auto">
              <h2 className="text-darkgray text-center text-[30px] leading-[65px] tracking-[-1px] mb-[65px] sm:leading-[50px] sm:mb-[25px]">
                Créer un nouveau compte
              </h2>
              <div className="p-16 border border-mediumgray" style={{ boxShadow: "20px 20px 20px rgba(0, 0, 0, 0.2)" }}>
                <h2 className="flex text-black text-start text-[20px] leading-[65px] tracking-[-1px] sm:leading-[50px] sm:mb-[25px]">
                  Utilisateur principal
                </h2>
                <div className="grid gap-6 mb-6 grid-cols-2">
                  <div>
                    <label htmlFor="company_name" className="block mb-2 text-sm font-medium text-gray">
                      Raison Sociale: <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="company_name"
                      name="company_name"
                      onChange={onChangeInputAdd}
                      className="bg-white border border-danger text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-danger block w-full p-2.5"
                      placeholder="Saisir votre Raison Sociale"
                      value={addClient.company_name}
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="tax_registre" className="block mb-2 text-sm font-medium text-gray">
                      Matricule Fiscal: <span className="text-danger">*</span>
                    </label>
                    <input
                      type="tel"
                      id="tax_registre"
                      name="tax_registre"
                      onChange={onChangeInputAdd}
                      className="bg-white border border-danger text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-danger block w-full p-2.5"
                      placeholder="Saisir votre Matricule Fiscal"
                      value={addClient.tax_registre}
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray">
                      Numéro de téléphone: <span className="text-danger">*</span>
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      onChange={onChangeInputAdd}
                      className="bg-white border border-danger text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-danger block w-full p-2.5"
                      placeholder="Saisir votre N° de téléphone"
                      value={addClient.phone}
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="Gouvernorat" className="block mb-2 text-sm font-medium text-gray">
                      Gouvernerat: <span className="text-danger">*</span>
                    </label>
                    <select
                        name="Gouvernorat"
                        id="Gouvernorat"
                        onChange={handleGouvernoratChange}
                        value={NomGouvernerat}
                        className="bg-white border border-danger text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-danger block w-full p-[12px]"
                        required
                      >
                        <option value="">Sélectionnez Gouvernorat</option>
                        {Gouvernerats.Gouvernorat.map((item, index) => (
                          <option key={index} value={item.Nom}>
                            {item.Nom}
                          </option>
                        ))}
                      </select>
                  </div>
                  <div>
                    <label htmlFor="adresse" className="block mb-2 text-sm font-medium text-gray">
                      Adresse: <span className="text-danger">*</span>
                    </label>
                      <input
                        type="text"
                        id="adresse"
                        name="adresse"
                        onChange={onChangeInputAdresse}
                        className="bg-white border border-danger text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-danger block w-full p-2.5"
                        placeholder="Saisir votre adresse"
                        value={address.adresse}
                        required
                      />
                  </div>
                  <div>
                    <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray">
                      Nom:
                    </label>
                    <input
                      type="text"
                      id="first_name"
                      name="first_name"
                      onChange={onChangeInputAdd}
                      className="bg-white border border-success text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-success block w-full p-2.5"
                      placeholder="Saisir votre nom"
                      value={addClient.first_name}
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="last_name" className="block mb-2 text-sm font-medium text-gray">
                      Prénom:
                    </label>
                    <input
                      type="text"
                      id="last_name"
                      name="last_name"
                      onChange={onChangeInputAdd}
                      className="bg-white border border-success text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-success block w-full p-2.5"
                      placeholder="Saisir votre prénom"
                      value={addClient.last_name}
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray">
                      E-mail:
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      onChange={onChangeInputAdd}
                      className="bg-white border border-success text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-success block w-full p-2.5"
                      placeholder="Saisir votre e-mail"
                      value={addClient.email}
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray">
                      Mot de passe: <span className="text-danger">*</span>
                    </label>
                    <div className="relative w-full">
                      <input
                        id="password"
                        name="password"
                        type={isPasswordVisible ? 'text' : 'password'}
                        onChange={onChangeInputAdd}
                        className={`w-full px-4 py-3.5 rounded-xl border-2 border-danger focus:border-danger focus:ring-danger transition-all pr-12`}
                        placeholder="••••••••"
                        value={addClient.password}
                        required
                      />
                      <button
                        type="button"
                        className="absolute inset-y-0 right-0 flex items-center px-4 text-gray-600"
                        onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                      >
                        {isPasswordVisible ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-5 h-5"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-5 h-5"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                            />
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                          </svg>
                        )}
                      </button>
                    </div>
                      {passwordError && <p className="text-red-600 text-sm mt-1">{passwordError}</p>}
                  </div>
                  <div>
                    <label htmlFor="confirmPassword" className="block mb-2 text-sm font-medium text-gray">
                      Confirmation Mot de passe: <span className="text-danger">*</span>
                    </label>
                    <div className="relative w-full">
                      <input
                        id="confirmPassword"
                        name="confirmPassword"
                        type={isPasswordVisibleConfirme ? 'text' : 'password'}
                        onChange={onChangeInputAdd}
                        className="w-full px-4 py-3.5 rounded-xl border-2 border-danger focus:border-danger focus:ring-danger transition-all pr-12"
                          placeholder="••••••••"
                          value={confirmPassword}
                        required
                      />
                      <button
                        type="button"
                        className="absolute inset-y-0 right-0 flex items-center px-4 text-gray-600"
                        onClick={() => setIsPasswordVisibleConfirme(!isPasswordVisibleConfirme)}
                      >
                        {isPasswordVisibleConfirme ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-5 h-5"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-5 h-5"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                            />
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                          </svg>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
                <hr className="h-px my-8 bg-gray-400 border-0" />
                <div className="flex items-start mb-6">
                  <div className="flex items-center h-5">
                    <input
                      id="remember"
                      type="checkbox"
                      name="conditions_generales_acceptees"
                      checked={addClient.conditions_generales_acceptees}
                      onChange={onChangeInputAdd}
                      className="w-4 h-4 border border-gray-300 rounded bg-white focus:ring-3 focus:ring-blue-300"
                    />
                  </div>
                  <label htmlFor="remember" className="ms-2 text-sm font-medium text-gray-900">
                    J'accepte{' '}
                    <a href="#" className="text-blue-600 hover:underline">
                      les termes et conditions
                    </a>
                    .
                  </label>
                </div>
                <div className="mx-auto w-[209px]">
                  <Buttons
                    type="submit"
                    aria-label="Créer mon compte"
                    className="btn-fill rounded-none font-medium font-serif mb-0 uppercase sm:mb-[15px]"
                    themeColor="#558927"
                    size="md"
                    color="#fff" 
                    onClick={AjouterClient}
                    title="Créer mon compte"
                  />
                </div>
                <div className="text-center mt-6">
                  <p className="text-sm text-gray-600">
                    Déjà un compte ?{' '}
                    <Link to="/login-register" className="text-blue-600 hover:underline">
                      Se connecter
                    </Link>
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </m.section>
    </div>
  );
};

export default Register;